import { render, staticRenderFns } from "./NewProfileModal.vue?vue&type=template&id=c2ae4dde&scoped=true&"
import script from "./NewProfileModal.vue?vue&type=script&lang=js&"
export * from "./NewProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./NewProfileModal.vue?vue&type=style&index=0&id=c2ae4dde&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ae4dde",
  null
  
)

export default component.exports